import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteFavorisOrder } from 'redux/actions/orderActions';
import FavoritesOrder from './FavoritesOrder';

const mapStateToProps = ({ layout }) => {
    const { locale, userData } = layout;
    return {
        locale,
        userData: userData.data,
    };
};

export default withRouter(connect(mapStateToProps, { deleteFavorisOrder })(FavoritesOrder));
